import React from "react";
import { Tooltip } from "@mui/material";


const ShowCountSKA = ({ count, list, spaceWithCount }) => {
    return (
        <Tooltip title={<span style={{ whiteSpace: "pre-line" }}>{list ? list.join("\n") : ""}</span>} placement="left"
            slotProps={{
                popper: {
                    modifiers: [
                        {
                            name: "offset",
                            options: {
                                offset: spaceWithCount
                            }
                        }
                    ]
                }
            }}>
            <span className={count === 0 ? "" : "tooltipInteractive"} >
                <div className="showcount-div">
                    {count}
                </div>
            </span>
        </Tooltip>
    );
};

export default ShowCountSKA;
